export const iconFontAwesomeShapesHeartCrack = (
	<i className="fa-solid fa-heart-crack"></i>
);
